import { useDimensions } from './dimensions.js'

export const useUIMode = () => {
  const { isSmallOrSmaller } = useDimensions()
  return isSmallOrSmaller ? 'mobile' : 'full'
}
